import { render } from "./MagentoServices.vue?vue&type=template&id=10407f43"
import script from "./MagentoServices.vue?vue&type=script&lang=js"
export * from "./MagentoServices.vue?vue&type=script&lang=js"

import "./MagentoServices.vue?vue&type=style&index=0&id=10407f43&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__